import mixpanel from 'mixpanel-browser'

import getCookieConsentValue from './helpers/client/get-cookie-consent-value'

const mixpanelToken = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || '1d7bb2f7d481e6ee0f272ccda467edb3'

function updateConfig(): void {
  mixpanel.set_config({
    disable_persistence: !getCookieConsentValue(),
  })
}

mixpanel.init(mixpanelToken, {
  debug: /true/i.test(process.env.NEXT_PUBLIC_MIXPANEL_DEBUG || 'true'),
  disable_persistence: !getCookieConsentValue(),
})

export { mixpanel, updateConfig }
